import React from 'react';
import { connect } from 'react-redux';

import { actionShared } from '../../containers/Widget/actions.js';

import ShareButton from './ShareButton';

import FacebookIcon from '../Svg/FacebookIconFooter';
import PropTypes from 'prop-types';

const facebookClickAction = (shareUrl, isEmbed, widgetRequestId) => {
    if (isEmbed) shareUrl += `?widgetId=${widgetRequestId}`;
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        shareUrl
    )}`;
    window.open(url, 'popup', 'width=600,height=600');
    return true;
};

const FacebookShare = props => (
    <ShareButton
        handleClick={() =>
            facebookClickAction(props.shareUrl, props.isEmbed, props.widgetRequestId) &&
            props.actionShared('facebook')
        }
    >
        <FacebookIcon />
    </ShareButton>
);

FacebookShare.propTypes = {
    actionShared: PropTypes.func.isRequired,
    isEmbed: PropTypes.bool.isRequired,
    shareUrl: PropTypes.string.isRequired,
    widgetRequestId: PropTypes.string.isRequired
};

export default connect(
    state => ({
        isEmbed: state.widget.articleUrl.includes('embed'),
        widgetRequestId: state.widget.widgetRequestId,
        shareUrl: state.widget.articleUrl
    }),
    {
        actionShared
    }
)(FacebookShare);
